import { FocusEvent, ReactNode } from 'react'
import {
  SurveyQuestion,
  SurveyQuestionType,
  SurveyMode,
} from '../../dtos/survey.dto'
import type { LastQuestionRemoval } from './question-builder/question-builder.types'

export interface SurveyFields {
  surveyEnabled?: boolean
  surveyMode?: SurveyMode
  surveyExternalUrl?: string
  surveyQuestions?: SurveyQuestion[]
}
export interface SurveySectionProps {
  hideModePicker?: boolean
  allowedQuestionTypes?: SurveyQuestionType[]
  maxQuestions?: number
  survey: SurveyFields
  setFieldValue: (field: string, value: unknown) => void
  setFieldTouched: (field: string, touched?: boolean) => void
  handleBlur: (e: FocusEvent<HTMLInputElement>) => void
  getDefaultQuestions?: () => SurveyQuestion[]
  fieldNames?: {
    enabled?: string
    mode?: string
    externalUrl?: string
    questions?: 'surveyQuestions' | 'preEventSurveyQuestions'
  }
  // Validation props
  errors?: Record<
    string,
    string | Array<{ label?: string } | undefined> | undefined
  >
  touched?: Record<
    string,
    boolean | Array<{ label?: boolean } | undefined> | undefined
  >
  // Text content props
  checkboxLabel: string
  checkboxHelperText: string
  builtInOptionTitle: string
  builtInOptionDescription: string
  externalOptionTitle: string
  externalOptionDescription: string
  externalUrlLabel: string
  externalUrlDescription: string
  externalUrlPlaceholder: string
  // QuestionBuilder text props
  questionBuilderHeaderTitle: string
  questionBuilderHeaderDescription: string
  addQuestionButton: string
  defaultRatingMinLabel: string
  defaultRatingMaxLabel: string
  typeLabel: string
  questionLabel: string
  requiredLabel: string
  questionPreviewLabel: string
  selectTypePlaceholder: string
  ratingQuestionPlaceholder: string
  freeTextQuestionPlaceholder: string
  removeButton: string
  ratingTypeLabel: string
  freeTextTypeLabel: string
  activeBadgeLabel: string
  deactivatedBadgeLabel: string
  questionResponseSummaryByIndex?: Partial<Record<number, string>>
  deactivateButtonLabel: string
  activateButtonLabel: string
  onDeactivateRequest?: (index: number, onConfirm: () => void) => void
  onActivateRequest?: (index: number, onConfirm: () => void) => void
  lastQuestionRemoval?: LastQuestionRemoval
  templatePicker?: ReactNode
  /** When true, the checkbox is disabled and all interactive content (mode picker, template picker, question builder) is hidden. */
  readOnly?: boolean
  /** Tooltip text shown when readOnly is true. */
  readOnlyTooltip?: string
}
